/**
 * Smoothly scrolls to a section on the page, accounting for fixed header height
 * @param elementId - The ID of the element to scroll to (without the # symbol)
 * @param offset - Additional offset in pixels (default: 80 for fixed header)
 */
export const scrollToSection = (elementId: string, offset: number = 80) => {
  const element = document.getElementById(elementId)
  if (element) {
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - offset
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }
}
/**
 * Sets up click handlers for all internal anchor links on the page
 * Call this in useEffect when the component mounts
 */
export const setupAnchorLinks = () => {
  const handleAnchorClick = (e: MouseEvent) => {
    const target = e.target as HTMLAnchorElement
    if (target.tagName === 'A' && target.hash) {
      const href = target.getAttribute('href')
      if (href && href.startsWith('#')) {
        e.preventDefault()
        const elementId = href.substring(1)
        scrollToSection(elementId)
        // Update URL without triggering navigation
        window.history.pushState(null, '', href)
      } else if (href && href.includes('#')) {
        // Handle links like "/page#section"
        const [path, hash] = href.split('#')
        if (window.location.pathname === path) {
          e.preventDefault()
          scrollToSection(hash)
          window.history.pushState(null, '', href)
        }
      }
    }
  }
  document.addEventListener('click', handleAnchorClick)
  // Handle initial hash on page load
  if (window.location.hash) {
    setTimeout(() => {
      const elementId = window.location.hash.substring(1)
      scrollToSection(elementId)
    }, 100)
  }
  return () => {
    document.removeEventListener('click', handleAnchorClick)
  }
}
